import { render, staticRenderFns } from "./MultiVideoEditor.vue?vue&type=template&id=025bda32&"
import script from "./MultiVideoEditor.vue?vue&type=script&lang=js&"
export * from "./MultiVideoEditor.vue?vue&type=script&lang=js&"
import style0 from "./MultiVideoEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports